/// <amd-module name="Artifacts/Maven/helpers/MavenFileHelper" />
import { IPackageVersion } from "Artifacts/Root/types/IPackageVersion";
import * as StringUtils from "VSS/Core/Util/String";

export interface IMavenFile {
  name: string;
  key: string;
}

export function getFiles(packageVersion: IPackageVersion): IMavenFile[] {
  const fileNames: IMavenFile[] = [];

  if (packageVersion.files) {
    packageVersion.files.forEach((file) => {
      if (!isHashFile(file.name)) {
        fileNames.push({
          name: file.name,
          key: file.name,
        });
      }
    });
  }
  return fileNames;
}

export function getMetadata(packageVersion: IPackageVersion): IMavenFile[] {
  const metadataFiles: IMavenFile[] = [];

  if (isSnapshotVersion(packageVersion)) {
    metadataFiles.push({
      name: "snapshot/maven-metadata.xml",
      key: "snapshotMetadata",
    });
  }

  metadataFiles.push({
    name: "artifact/maven-metadata.xml",
    key: "artifactMetadata",
  });

  metadataFiles.push({
    name: "index.json",
    key: "artifactIndex",
  });

  return metadataFiles;
}

export function isSnapshotVersion(packageVersion: IPackageVersion): boolean {
  return packageVersion.version.toLowerCase().indexOf("-snapshot") > -1;
}

function isHashFile(fileName: string): boolean {
  const ignoreCase = true;
  return (
    StringUtils.endsWith(fileName, ".md5", ignoreCase) ||
    StringUtils.endsWith(fileName, ".sha1", ignoreCase)
  );
}
